module.exports = __webpack_public_path__ + "img/frame (266).be4968ff.jpg";